/* eslint-disable @typescript-eslint/no-explicit-any */
import { TApplicationState } from '../../types/redux';
import { IInteriorDecoration } from '../../types/newbuilding/decoration';

export function getInteriorDecoration(state: TApplicationState): IInteriorDecoration[] {
  const items = state.newbuilding.interiorDecoration;

  return (items as any).filter(({ images }: any) => images.length);
}
